import { render } from "./NavbarLink.vue?vue&type=template&id=901591a4&scoped=true"
import script from "./NavbarLink.vue?vue&type=script&lang=js"
export * from "./NavbarLink.vue?vue&type=script&lang=js"

import "./NavbarLink.vue?vue&type=style&index=0&id=901591a4&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901591a4"]])

export default __exports__